import React, {useEffect} from 'react';
import Clickable from './Clickable';
import Button from './Button';
import { AiOutlineClose } from "@react-icons/all-files/ai/AiOutlineClose";
import { AiOutlineRight } from "@react-icons/all-files/ai/AiOutlineRight";
import { AiOutlineUp } from "@react-icons/all-files/ai/AiOutlineUp";
import { useSelector, useDispatch } from 'react-redux';
import { toggleLeftMenu, getLeftMenu } from '../store/slices/ui';
import { getMedia } from '../store/slices/user';


const LeftMenu = ({ children, button, collap, name, className, openOption, noClose, onClose, noHeader }) => {
  let dispatch = useDispatch()
  let open = useSelector(getLeftMenu)
  let { tablet, mobile, desktop } = useSelector(getMedia)
  let closeFunc = onClose || (() => dispatch(toggleLeftMenu()))

  useEffect(() => {
    if((tablet || mobile) && !noClose && !onClose) dispatch(toggleLeftMenu(false))
},  [tablet, mobile])

if(!desktop) return <div></div>

  if(!open && (tablet || mobile) && !onClose) return openOption ||  <aside data-msr-surface='light' className='leftMenu-closed' onClick={closeFunc} >
{mobile ? <AiOutlineUp  id='rm-icon' />  :  <AiOutlineRight id='rm-icon' />}
</aside>

  return <>
  {(tablet || mobile) && !noHeader && <div data-msr-surface='light' className='menuHeader'>
    <span>{name || 'Menu'}</span>
    <Clickable onClick={closeFunc} >  <AiOutlineClose /></Clickable>
  </div>}

    <aside data-msr-surface='light' className={`leftMenu ${collap ? 'collap' : ''} ${className || ''}`} >
      <div className='leftMenu-col'>
      {children}
      {(tablet || mobile) && button && <div data-msr-surface='light' className='menuFooter'>
        <Button className='btn-4 highLight' onClick={closeFunc}>{button}</Button>

      </div>}
      </div>
    </aside>

    {(tablet || mobile) && <div className='menuBack' onClick={closeFunc} ></div>}
  </>
}

export default React.memo(LeftMenu)
